import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Kicker, Reveal } from "../components/Reveal";
import { api } from "../lib/api";

function Stars({ rating }) {
  return (
    <div className="flex gap-1">
      {Array.from({ length: rating }).map((_, i) => (
        <Star key={i} size={14} className="fill-gold-dark text-gold-dark" />
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials").then((res) => setItems(res.data)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;
  const hasPlaceholders = items.some((i) => i.is_placeholder);

  return (
    <section id="testimonials" data-testid="testimonials-section" className="border-t border-linen bg-ivory py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <Reveal>
          <Kicker>Kind Words</Kicker>
          <h2 className="mt-4 max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
            What clients are saying
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.05}>
              <figure
                data-testid={`testimonial-card-${t.id}`}
                className="flex h-full flex-col rounded-lg border border-linen p-7"
              >
                <Stars rating={t.rating} />
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-forest">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6">
                  <p className="text-sm font-semibold text-forest">{t.name}</p>
                  {t.treatment && <p className="mt-0.5 text-xs text-moss">{t.treatment}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        {hasPlaceholders && (
          <p data-testid="testimonials-disclaimer" className="mt-10 text-xs italic text-moss/70">
            Sample testimonials shown — real client reviews coming soon.
          </p>
        )}
      </div>
    </section>
  );
}
